import { embeddedRuntime } from '@/config'
import { sendMessage } from '@/modules/extension/utils/messaging'

export const logout = () => {
  if (embeddedRuntime()) sendMessage('logout')
  location.href = `/access/logout?return_to=${encodeURIComponent('/qa')}`
}
